import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";

import "./body.css";
import "./fave.css";
import whyImage from "../why.jpg";
import "./why.css";

const PARALLAX_BREAKPOINT = 1100;
const PARALLAX_SPEED = -0.12;

function How() {
    const [parallaxOffset, setParallaxOffset] = useState(0);
    const [isParallaxActive, setIsParallaxActive] = useState(() =>
        typeof window !== "undefined" ? window.innerWidth >= PARALLAX_BREAKPOINT : false
    );
    const initialScrollRef = useRef(null);

    useEffect(() => {
        document.title = "Invest With Knowledge! - How This Works";
    }, []);

    useEffect(() => {
        if (typeof window === "undefined") {
            return undefined;
        }

        let frame = null;

        const updateParallax = () => {
            const shouldActivate = window.innerWidth >= PARALLAX_BREAKPOINT;
            setIsParallaxActive(shouldActivate);

            if (!shouldActivate) {
                initialScrollRef.current = null;
                setParallaxOffset(0);
                return;
            }

            if (initialScrollRef.current === null) {
                initialScrollRef.current = window.scrollY;
            }

            const delta = window.scrollY - initialScrollRef.current;
            setParallaxOffset(delta * PARALLAX_SPEED);
        };

        const handleScroll = () => {
            if (frame !== null) {
                return;
            }
            frame = window.requestAnimationFrame(() => {
                frame = null;
                updateParallax();
            });
        };

        updateParallax();
        window.addEventListener("scroll", handleScroll, { passive: true });
        window.addEventListener("resize", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
            window.removeEventListener("resize", handleScroll);
            if (frame !== null) {
                window.cancelAnimationFrame(frame);
            }
        };
    }, []);

    const parallaxStyle = isParallaxActive
        ? { transform: `translateY(${parallaxOffset}px)` }
        : undefined;

    return (
        <section className="mainbody">
            <h2 className="responsiveheader">How This Works</h2>
            <section className="whywrapper">
                <section>
                    <p>
                        "The early Greeks used to sit around for days and debate about how
                        many teeth a horse has. They thought they could figure it out just
                        by sitting there, instead of checking the horse. A lot of investors
                        sit around and debate whether a stock is going up, as if the
                        financial muse will give them the answer, instead of checking the
                        company."
                    </p>
                    <p>-Peter Lynch</p>
                    <section className="leftsection">
                        <img src={whyImage} alt="Josiah Swanson, Investing"></img>
                    </section>
                    <section className="rightsection" style={parallaxStyle}>
                        <p>
                            Josiah Swanson, the creator of this website, loves data-driven decision-making, and his whole goal with Invest With
                            Knowledge! is to help people to see that good companies, over
                            time, perform well as stocks!
                        </p>
                    </section>
                    <section className="anotherrightsection">
                        <p>
                            Here at Invest With Knowledge!, we promote checking the company.
                            Specifically, we promote the discovery of valuable assets that are
                            typically ignored by Wall Street because they sound boring and
                            weird.
                        </p>

                        <h3>Benjamin Graham &amp; The Intelligent Investor</h3>
                        <p>
                            Inspired by the founder of value investing, Benjamin Graham,
                            we base our entire stock selection process on his book,
                            <span>The Intelligent Investor</span>. The book is pretty long
                            and can be confusing at times, but chapters fourteen and fifteen
                            elucidate a stock selection process for aspiring value
                            investors. So, in order for a stock to show up on this site, it must
                            fit the criteria outlined in those two chapters.

                        </p>
                        <h3>What We Look For:</h3>

                        <p>
                            First things first, we filter out all the stocks in the S&P 500. We'd
                            like to spend most of our research time on stocks that most people
                            won't pay attention to.
                        </p>
                        <p>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Next, we apply the <Link to="/criteria">criteria</Link> outlined by Graham in
                            chapters fourteen
                            and fifteen of <span>The Intelligent Investor.</span> Every stock
                            we report has (at least once) passed the tests given in one or both of the
                            chapters.
                        </p>


                        <h3>What We Leave Out:</h3>
                        <p>
                            Not every company qualifies for analysis. If critical information is missing,
                            broken, or inconsistent, the stock is removed before screening. This ensures
                            that our results stay clean and meaningful.
                        </p>

                    </section>
                </section>
            </section>
        </section>
    );
}

export default How;
